import React, { useState } from "react";
import { useTranslation } from "../i18n/TranslationProvider";
import { translateDataValue } from "../i18n/translateData";

import Form from "react-bootstrap/Form";
import MedicalPillButton from "./StyledComponents/MedicalPillButton";
import doubleImage from "../images/double vision.png";
import wordMovingImage from "../images/saccades.png";

const MedicalListSelector = ({
  addSymptoms,
  patient,
  category,
  list,
  maxSelectAmount,
  selectedList,
  toggleFromSelectedList,
  selectOne,
  addOther,
  index,
  noOther,
  noSuffix,
  setHeadacheParts,
  headacheParts,
  message,
  symptom_selector
}) => {
  const { t } = useTranslation();

  // `list` holds DISPLAYED (translated) labels, so compare against the
  // translated label for the current language, plus the English original.
  const labelsFor = (category, english) => [
    english,
    translateDataValue(t, "onboarding.symptomList", category, english),
  ];
  const DOUBLE_VISION = labelsFor("vision", "Double vision");
  const WORDS_MOVE = labelsFor("vision", "Words move when reading");
  const HEADACHE_CLOSE_WORK = labelsFor("vision", "Headaches caused by close work: computers, reading, gaming");
  const MENSTRUAL_CYCLE = [
    "Menstrual Cycle",
    translateDataValue(t, "onboarding.triggerList", "wellness", "Menstrual Cycle"),
  ];
  // 'new item' is the item that will be appended to the returned data
  // if a user adds to 'other' field.
  const [newItem, setNewItem] = useState("");
  const [showDoubleVision, setShowDoubleVision] = useState(false);
  const [showWordMoving, setShowWordMoving] = useState(false);
  const naItems = ["N/A", "n/a", "NA", "na"];
  // suffix shows the user how many to choose
  let suffix;
  if (!noSuffix) {
    if (!maxSelectAmount) {
      suffix = ` (${t("onboarding.choose.chooseAll")}) `;
    } else {
      suffix = ` (${t("onboarding.choose.choose")} ${maxSelectAmount}) `;
    }
  }

  // Works in every language (previously only matched the English label)
  if (patient?.gender == "male") {
    list = list.filter(item => !MENSTRUAL_CYCLE.includes(item));
  }

  const colors = {
    motor: "#b3e5fc",
    sensory: "#ffccbc",
    emotional: "#dab7ec",
    behavioral: "#ffdadb",
    cognitive: "#ffdcaf",
    immune: "#fff3c4",
    metabolic: "#cef3c4",

    // for trigger
    wellness: "#dab7ec",
    travel: "#ffdadb",
    "screen time": "#ffdcaf",
    environmental: "#fff3c4",
    Dietary: "#cef3c4",
    situational: "#c1fdf7",

    // for therapies
    Alternative: "#dab7ec",
    Applied: "#ffdadb",
    Chiropractic: "#ffdcaf",
    Vision: "#fff3c4",
    "Mental Health": "#c1fdf7",

    Other: "#f4f3ee",
  };

  const handleChange = (event) => {
    setNewItem(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (
      event.key === "Enter" ||
      (!event.currentTarget.contains(document.activeElement) &&
        newItem !== "" &&
        !naItems.includes(newItem))
    ) {
      const formattedItem = addOther(newItem, index);
      if (maxSelectAmount === 1) {
        selectOne(formattedItem, category);
      } else {
        toggleFromSelectedList(
          formattedItem,
          selectedList,
          category,
          maxSelectAmount
        );
      }
      setNewItem("");
    }
  };

  const toggleHelpImg = (item, status) => {
    if (DOUBLE_VISION.includes(item) || WORDS_MOVE.includes(item)) {
      if (DOUBLE_VISION.includes(item) && status === "enter") {
        setShowDoubleVision(true);
      } else if (WORDS_MOVE.includes(item) && status === "enter") {
        setShowWordMoving(true);
      } else {
        setShowDoubleVision(false);
        setShowWordMoving(false);
      }
    }
  };

  const onChange = (e) => {
    let newValue = e.target.value;
    if (e.target.checked && !headacheParts.includes(newValue)) {
      setHeadacheParts((selectedList) => [...selectedList, newValue]);
    } else if (!e.target.checked) {
      setHeadacheParts(headacheParts.filter((item) => item !== newValue));
    }
  };

  const style = addSymptoms
    ? {
      color: 'black',
      border: 'white',
      textAlign: "left",
      fontWeight: "normal",
      fontSize: "15px",
      display: "symptom_selector" ? "block" : "inline-block",
    }
    : {
      color: 'black',
      border: 'white',
      textAlign: "left",
      display: "symptom_selector" ? "block" : "inline-block",
    };

  return (
    <div className="listSelector"
      style={{
        height: "30rem",
        overflow: 'scroll',
        fontWeight: "normal",
        fontSize: "15px"
      }}>
      <div className="mb-2">
        <h6 className="d-inline">{message}</h6>
        <em className="d-inline">{suffix}</em>
      </div>

      {list?.map((selectableItem) => (
        <span key={selectableItem + 0}>
          <MedicalPillButton
            onClick={() =>
              maxSelectAmount === 1
                ? selectOne(selectableItem, category)
                : toggleFromSelectedList(
                  selectableItem,
                  selectedList,
                  category,
                  maxSelectAmount
                )
            }
            onMouseOver={() => {
              toggleHelpImg(selectableItem, "enter");
            }}
            onMouseOut={() => {
              toggleHelpImg(selectableItem, "leave");
            }}
            variant={
              "light"
            }
            key={selectableItem}

            style={style}
          >
            {
              selectedList.includes(selectableItem) ? (
                // <div>

                <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  <title>icon/action/check_ccircle_24px</title>
                  <defs>
                    <path d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M10,17 L5,12 L6.41,10.59 L10,14.17 L17.59,6.58 L19,8 L10,17 Z" id="path-1"></path>
                  </defs>
                  <g id="icon/action/check_ccircle_24px" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <mask id="mask-2" fill="white">
                      <use xlinkHref="#path-1"></use>
                    </mask>
                    <use id="-↳Color" fill={colors[category]} xlinkHref="#path-1"></use>
                  </g>
                </svg>
                // </div>
              ) : (
                <svg width="24px" height="24px" viewBox="0 0 22 22">
                  <circle cx="11" cy="11" r="9.5" stroke="grey" strokeWidth="1" fill="white" />
                </svg>
              )
            }
            {" "}
            {selectableItem}
          </MedicalPillButton>
          {DOUBLE_VISION.includes(selectableItem) && showDoubleVision ? (
            <img
              className="helpImage"
              alt={t("onboarding.medicalListSelector.doubleVisionAlt")}
              src={doubleImage}
              key={selectableItem + 1}
            />
          ) : null}
          {WORDS_MOVE.includes(selectableItem) && showWordMoving ? (
            <img
              className="helpImage"
              alt={t("onboarding.medicalListSelector.wordMovingAlt")}
              src={wordMovingImage}
              key={selectableItem + 2}
            />
          ) : null}
        </span>
      ))
      }
      {
        (HEADACHE_CLOSE_WORK.some((label) => selectedList.includes(label))
        ) && headacheParts ? (
          <>
            <Form className="headacheForm">
              <label className="w-100">
                {t("onboarding.headacheLocation.label")}
              </label>
              {[
                { label: t("onboarding.headacheLocation.fore"), value: "Fore" },
                { label: t("onboarding.headacheLocation.backtop"), value: "BackTop" },
                { label: t("onboarding.headacheLocation.right"), value: "Right" },
                { label: t("onboarding.headacheLocation.left"), value: "Left" },
                { label: t("onboarding.headacheLocation.behind"), value: "Behind" },
                { label: t("onboarding.headacheLocation.eyes"), value: "Eyes" },
                { label: t("onboarding.headacheLocation.backbottom"), value: "BackBottom" },
                { label: t("onboarding.headacheLocation.all"), value: "All" },
              ].map((location, i) => (
                <Form.Check
                  inline
                  label={location.label}
                  value={location.value}
                  type="checkbox"
                  name="headachePart"
                  key={i}
                  onChange={onChange}
                  checked={headacheParts.includes(location.value) ? true : false}
                />
              ))}
            </Form>
            <hr></hr>
            <br></br>
          </>
        ) : null
      }
      {
        noOther ? (
          ""
        ) : (
          <label htmlFor={`${category}-other`} className="w-100">
            {t("onboarding.other")}: &nbsp;
            <input
              value={newItem}
              onChange={handleChange}
              onKeyPress={handleKeyPress}
              onBlur={handleKeyPress}
              aria-label={t("onboarding.medicalListSelector.otherAriaLabel")}
              id={`${category}-other`}
              style={{
                border: "0",
                outline: "0",
                background: "transparent",
                borderBottom: "2px solid black",
                width: "33%",
              }}
              name="other"
              placeholder={t("onboarding.other")}
            />
          </label>
        )
      }
    </div >
  );
};

export default MedicalListSelector;